import mongoose from 'mongoose';

export enum EQuickAccessWidgetStatus {
  inactive,
  active
}

export interface IQuickAccessWidget {
  nameVi: string;
  nameEn: string;
  backgroundImage: mongoose.Types.ObjectId;
  link: string;
  status: EQuickAccessWidgetStatus;
}
